import {AppService} from "@/service/app.service";
import {AxiosService} from "@/service/axios.service";
import {KRBS_CIRCULARS} from "@/config/constants.config";
import {toLower} from "lodash";
const state={
    circular_categories:{},
    filteredCategories:[],
    selectedCategory:'',
}
const mutations={
    SET_CIRCUlAR_CATEGORIES:(state,categories)=>state.circular_categories=categories,
    SET_SELECTED_CIRCULAR_CATEGORY:(state,category)=>state.selectedCategory=category,
}
const actions={
   getCircularCategory({commit,rootState},payload){
       let userType=toLower(rootState.AuthModule.authUser.scope);
        commit('SET_CIRCUlAR_CATEGORIES',[])
        AxiosService.post(
            userType+KRBS_CIRCULARS.CIRCULAR_CATEGORIES.MENU,
            {circular_issue_id: payload}
        )
            .then((r)=>{
                commit('SET_CIRCUlAR_CATEGORIES',r.data.data)
            })
    },

}

const getters={
    circular_categories:(state)=>AppService.capitalizeProperties(state.circular_categories),
    filteredCategories:(state)=>state.filteredCategories,
    selectedCategory:(state)=>state.selectedCategory,
}

export default {state,mutations,actions,getters}